import { API } from 'aws-amplify';
import awsmobile from '../aws-exports';

import { getPhonemePlacementEnabled } from '../components/Reader/Speech/Speech';

import io from "socket.io-client";
import {logSessionInfo} from '../services/logger';
import get from 'lodash.get';
import { getUserData } from './API';
import { getScreeningWindow } from './screeningWindowService';

let predictionCallback=null;
let comprehensionCallback=null;
let timingCallback = null;
let onDetectionEndCallback = null;
let socket = null;
let transcript = "";    //This is the "base" transcript saved off whenever we disable the placement socket
let currentTranscript = ""; //This is the transcript returned for the current placement session.
let listening = false;
let pauseRequested = false;
let recording = false;
let kaldiTranscript = ""; //This is the Kaldi transcript from EDM
let placementDisconnects = 0;
let edmDisconnects = 0;
let totalBytesSent = 0;
let enabledServices = {PlacementManager: false, PhonPlacementManager: false, SpeechStream: false, Nrt: false, AmirabetPlacementManager: false, GooglePlacementManager: false, PhonemeASR: false, PartialSpeechStream: false, ComprehensionInference: false};
let useGoogleNRT = false;
let useSpanishPlacement = false;
let oneOffAudio = false;
let lastPhons = '';
let networkMonitoringService = null;
let audioDestination = null;
let adhocSequence = {};

const DEBUG_SOCKET = false;

export async function getRegionalURL(regionOverride){
  if(!regionOverride){
    const url = process.env.GLOBAL_DISCOVERY_URL;
    return fetch(url,{
      method: "GET",
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((resp) => resp.json())
    .then((resp)=>{
      console.log("discovery",resp)
      logSessionInfo('region_'+resp.discovery.region,resp)
      return {url: resp.discovery.address, region: resp.discovery.region}
    })
    .catch((err)=>{
      console.log("Error getting region",err)
      logSessionInfo('error_getting_region',{region: process.env.UNIFIED_SOCKET})
      return process.env.UNIFIED_SOCKET;
    })
  }else{
    const region = regionOverride === 'us-east-1' ? 'us-east-1' : 'us-east-2';
    const url = regionOverride === 'us-east-1' ? process.env.UNIFIED_SOCKET : process.env.UNIFIED_SOCKET_EAST_2;
    console.log("Overriding region to:",region,url);
    logSessionInfo('region_override',{region: region, url: url});
    return {url,region};
  }

}

function emit(socket, event, payload) {
  // TODO: UNDO THIS CHANGE
  if(DEBUG_SOCKET) {
    console.log(`%cEMIT ${event}`, 'background: #ffcc99; color: #000; padding: 1em;', JSON.stringify(Object.assign({}, payload, {'data': null}), null, 0));
  }
  socket && socket.emit(event, payload);
}

export const placementProxy = new Proxy({
  connected: null,
  onConnectedChange: null,
},{
  set: function(obj, prop, newValue) {
    if(obj[prop] !== newValue){
      if(prop === 'connected' && obj.onConnectedChange){
        obj.onConnectedChange(newValue);
      }
      obj[prop] = newValue;
    }
    return true;
  }
});
let placementCallback = null;
let phonCallback=null;
let amirabetCallback=null;
let phonASRCallback = null;

export function startEDMSession(inEDMCallback,inTimingCallback,onDetectionEnd){
  if(!socket){
    initUniversalSocket();
  }
  enabledServices.Nrt = true;
  predictionCallback = inEDMCallback;
  timingCallback = inTimingCallback;
  onDetectionEndCallback = onDetectionEnd;
}

export function startRecordingSession(){
  if(!socket){
    initUniversalSocket();
  }
  enabledServices.SpeechStream = true;
}

export async function initUniversalSocket(){
  //TODO: instead of using the URL received at startup, change on every activity.
  let socketURL = getUserData().speechStreamURL;
  if(!socketURL){
    socketURL = await getRegionalURL().url
  }

  logSessionInfo("socket_connecting",{event: 'connecting', timestamp: Date.now(),socketURL})
  socket = io(socketURL, {secure: true, 'connect timeout': 2000, timeout: 2000, transports: ['websocket']});

  var onevent = socket.onevent;
  socket.onevent = function (packet) {
    var args = packet.data || [];
    onevent.call (this, packet);    // original call
    packet.data = ["*"].concat(args);
    onevent.call(this, packet);      // additional call to catch-all
  };

  if(process.env.STREAM){
    socket.on('connect', ()=>{
      placementProxy.connected = true;
      console.log("connected to EDM socket", socket);
      enabledServices.SpeechStream = true;  //Enable saving audio by default
      placementProxy.connected = true;
      logSessionInfo("socket_connected",{event: 'connect',id: socket.id, timestamp: Date.now()});
    });

    socket.on('decodingError', (data) => {
      //console.log('Decoding error', { data });
    });

    socket.on('debug-steps', (data) => {
      //console.log('Google Recognizer step', { data }); Leave in for debugging
    });

    socket.on('audioSegment', (data) => {
      console.log('Data from Speech Socket', { data });
    });

    socket.on('connect_error', (error) => {
      console.log("Speech Socket Connect Error");
      logSessionInfo("socket_connect_error",{event: 'connect_error', error: error, timestamp: Date.now()});
    });

    socket.on('connect_timeout', (timeout) => {
      console.log("Speech Socket Connect Timeout");
      logSessionInfo("socket_connect_timeout",{event: 'connect_timeout', timeout: timeout, timestamp: Date.now()});
    });

    socket.on('disconnect', function(reason) {
      // else the socket will automatically try to reconnect
      onDisconnect(reason);
      console.log("Speech Socket Disconnect",reason);
      logSessionInfo("socket_disconnect",{event: 'disconnect', reason: reason, timestamp: Date.now()});
    });

    socket.on('reconnect_error', (error) => {
      console.log("Error reconnecting to socket",error);
      logSessionInfo("socket_reconnect_error",{event: 'reconnect_error', error: error, timestamp: Date.now()});
    });

    socket.on('reconnect_failed', () => {
      console.log("Reconnecting to socket failed");
      logSessionInfo("socket_reconnect_failure",{event: 'reconnect_failed', timestamp: Date.now()});
    });

    socket.on('reconnecting', function() {
      console.log("Speech Socket Reconnecting");
      logSessionInfo("socket_reconnect_failure",{event: 'reconnecting', timestamp: Date.now()});
    });

    socket.on('reconnect', function(attemptNumber) {
      placementProxy.connected = true;
      console.log("Speech Socket Reconnect successful");
      logSessionInfo("socket_reconnected",{event: 'reconnect', attemptNumber: attemptNumber, timestamp: Date.now()});
    });

    socket.on('*', function(data,payload) {
      processSpeechEvent(data,payload);
    });
  }
}

export function endUniversalSocketSession(timeout){
  if(timeout){
    window.setTimeout(endUniversalSocketSession,timeout);
  }else{
    socket && socket.disconnect();
    socket = null;
  }
}

function onDetectorsEnd(data){
  onDetectionEndCallback(get(data, 'flagging.detectors', []))
}

function onPrediction(data){
  console.log("Prediction from EDM:",Date.now(),JSON.stringify(data.prediction)); //TODO: Remove once confident in error detection
  if(predictionCallback && !data.error){
    predictionCallback(
      data.prediction,
      data.predictionConfidences, // confidenceLevels,
      data.interventions, // phraseInterventionWeights
    );
  }else{
    console.log("ERROR from EDM:",data.error);
    logSessionInfo('error_from_edm',data)
  }
}

function onComprehensionInference(data){
  console.log(`Comprehension Dialog: ${Date.now().toString()} - On Comprehension Inference`, data);
  logSessionInfo('on_comprehension_inference',data);
  comprehensionCallback(data);
}

function onDecoded(data){
  switch(data.service){
    case "PlacementManager":
      if(listening && data && data.result && data.result.text) currentTranscript = data.result.text;
      let transcriptToSend = oneOffAudio ? currentTranscript : transcript + currentTranscript;
      if(placementCallback){
        placementCallback(transcriptToSend);
        if (networkMonitoringService) {
          networkMonitoringService.handleOnDecoded();
        }
      }
      break;
    case "PhonPlacementManager":
      analyzePhonStream(data.result.text);
      break;
    case "Wav2VecStreamV2":
      analyzeAmirabetStream(data.result.text);
      break;
    case "Wav2VecPhonASR":
      analyzePhonASR(data.result.text)
      break;
  }
}

let lastPhonLength = 0;

function analyzePhonStream(phons){
  if(phons){
    let stream = phons.split("SIL").join("");
    //Replace multiple spaces
    stream = stream.replace(/ +(?= )/g,'');
    stream = stream.split(" ");
    stream = stream.filter((phon)=>phon !== "");
    lastPhonLength = stream.length;
    if(phonCallback) phonCallback(lastPhonLength);
  }

}

function analyzeAmirabetStream(phons){
  //If there have been no updates, just return
  if(phons === lastPhons) return;

  // We only want to issue deltas. We'll compare the strings in two ways:
  // 1. Find the first mismatched character. This will happen when the backend has changed an existing hypothesis
  // 2. If there are no updates, just take the part of the hypothesis that is new.
  let current = phons.split('');
  let previous = lastPhons.split('');
  let firstMismatch = 0;
  let amirabetPhons = '';

  //Deal with hyphotheses that have changed by finding the first mismatch
  for(firstMismatch;firstMismatch < previous.length;firstMismatch++){
    if(current[firstMismatch] !== previous[firstMismatch]){
      amirabetPhons = phons.substring(firstMismatch);
      break;
    }
  }

  //If there were no updated phons, simply grab any updates
  if(amirabetPhons === '' && current.length !== previous.length){
    amirabetPhons = phons.substring(previous.length);
  }

  amirabetPhons = amirabetPhons.trim();
  lastPhons = phons;
  if(amirabetCallback) amirabetCallback(amirabetPhons)
}

function analyzePhonASR(phons){
  let phonASRtranscript = phons.trim();
  if(phonASRCallback) phonASRCallback(phonASRtranscript)
}

function onSaved(data){
  if(!data){
    return;
  }

  if(buildSequence && (data.sequenceNumber == buildSequence)){
    buildAcknowledged = true;
    logSessionInfo("build_ack",{timeStamp: Date.now()});
  }
  acknowledgedSequence = data.sequenceNumber;
  if (networkMonitoringService) {
    networkMonitoringService.dequeueAudio(data.sequenceNumber, {
      buildSequence,
      acknowledgedSequence,
      buildAcknowledged,
    });
  }
}

function onDisconnect(reason){
  placementProxy.connected = false;
  if(reason !== "io client disconnect"){
    placementDisconnects++;
    edmDisconnects++;
    transcript += currentTranscript;
    currentTranscript="";
  }
}

function onASROutput(data){
  let usedFallback = false;

  if(data.asr == "kaldi"){
    if(timingCallback){
      timingCallback(data);
    }
    kaldiTranscript = data.data.text;
    usedFallback = (data.data.transcription[0].confidence === 0.850012345);
  }

  if(data.asr == "google"){
    usedFallback = (data.data.transcription[0][0][1] === 0.850012345);
  }

  let output = (data.asr !== "pocketSphinx") ? data.data.text : data.data.pocketsphinx_transcript;

  console.log('%cGot ASR data', 'background: #0c0; color: #fff; padding: 1em;', data.asr,usedFallback ? "FALLBACK":"",":",output);
}

export function getUnconstrainedTranscript(){
  return kaldiTranscript;
}

export function pauseSpeechSession(){
  if(recording && socket){
    pauseRequested = true;
    recording = false;
  }
}

export function resumeSpeechSession(){
  if(!recording && socket){
    socket && !recording && emit(socket, 'resume', { time: Date.now(), version: '2.0.0', services: { PlacementManager: true, PhonPlacementManager: true, AmirabetPlacementManager: true, GooglePlacementManager: true, SpeechStream: true, Nrt: true, PhonemeASR: true, PartialSpeechStream: true, ComprehensionInference: true}});

    //socket && !recording && send('resume',{services: { PlacementManager: true, SpeechStream: true, Nrt: true }});
    recording = true;
  }
}

export function endEDMSession(){
  emit(socket, 'stop', { time: Date.now(), version: '2.0.0', services: { Nrt: true }});
  predictionCallback = null;
  timingCallback = null;
  enabledServices.Nrt = false;
}

export function getAudioDuration(){
  //return the time in mS. This is a simplification of:
  // Time In Milliseconds = 1000 * (total bytes / sample size in bytes) / (sample rate)
  // which = 1000 * (bytes / 2 ) / 16000
  return Math.round(totalBytesSent/32);
}

export function startPlacementSession(callback,phCallback=null,enableAllServices=true,inGoogleNRT=false,abCallback=null,useAmirabetPlacement=false,useSpanish=false,usePhonemeASR=false,useComprehensionASR=false,paCallback=null,inAudioDestination=null,inComprehensionCallback=null){
  if(!socket){
    initUniversalSocket();
  }else{
    socket && emit(socket, "resume",{version: '2.0.0', services: {PlacementManager: true,  PhonPlacementManager: true, SpeechStream: true, AmirabetPlacementManager: true, GooglePlacementManager: true, PhonemeASR: true, PartialSpeechStream: true, ComprehensionInference: true}});
  }
  placementCallback = callback;
  phonCallback = phCallback;
  amirabetCallback = abCallback;
  phonASRCallback = paCallback;
  comprehensionCallback = inComprehensionCallback;
  listening = true;
  useGoogleNRT = inGoogleNRT;
  useSpanishPlacement = useSpanish;
  enabledServices.PlacementManager = enableAllServices && !useGoogleNRT && !useSpanishPlacement && !usePhonemeASR;
  enabledServices.GooglePlacementManager = useSpanishPlacement;
  enabledServices.PhonPlacementManager = !useAmirabetPlacement;
  enabledServices.AmirabetPlacementManager = useAmirabetPlacement;
  enabledServices.PartialSpeechStream = false;
  enabledServices.PhonemeASR = usePhonemeASR;
  enabledServices.SpeechStream = true;
  enabledServices.ComprehensionInference = useComprehensionASR;
  audioDestination = inAudioDestination;

  if (audioDestination) {
    if (!adhocSequence[audioDestination]) {
      adhocSequence[audioDestination] = 0;
    }
    enabledServices.PartialSpeechStream = true;
  }
}

export function endPlacementSession(){
  //Close the placement session;
  socket && emit(socket,"stop", {
    version: '2.0.0',
    services: {PlacementManager: true, PhonPlacementManager: true, SpeechStream: true, AmirabetPlacementManager: true, GooglePlacementManager: true, PhonemeASR: true, PartialSpeechStream: true, ComprehensionInference: true},
  });
  listening = false;
  if(!oneOffAudio){
    transcript += currentTranscript;
  }

  currentTranscript="";
}

export function resetPlacementTranscript(){
  transcript = "";
  currentTranscript = "";
  kaldiTranscript = "";
  logSessionInfo("socket_disconnects",{placement: placementDisconnects, edm: edmDisconnects});
}

function sendPause(){
  //###console.log("PAUSE")
  socket && emit(socket, 'pause',{ time: Date.now(), version: '2.0.0', services: { PlacementManager: true, PhonPlacementManager: true, AmirabetPlacementManager: true, GooglePlacementManager: true, SpeechStream: true, Nrt: true, PhonemeASR: true, PartialSpeechStream: true, ComprehensionInference: true }});
}

export function getDisconnects(){
  return {placementDisconnects: placementDisconnects, edmDisconnects: edmDisconnects};
}

export function initSocketCounters(){
  placementDisconnects = 0;
  edmDisconnects = 0;
  sequenceNumber = 0;
  buildSequence = 0;
  totalBytesSent = 0;
  acknowledgedSequence = 0;
  buildAcknowledged = false;
  adhocSequence = {};
}

let sequenceNumber = 0;
let acknowledgedSequence = 0;
let buildSequence = 0;
let buildAcknowledged = false;

function send(type, message) {
  const payload = Object.assign(message,{version: '2.0.1' });
  //console.log(type,JSON.stringify(message.services));
  socket && emit(socket, type, payload);
}

function stopAll(){
  emit(socket, 'stop', { time: Date.now(), version: '2.0.0', services: { PlacementManager: true, PhonPlacementManager: true, AmirabetPlacementManager: true, GooglePlacementManager: true, SpeechStream: true, Nrt: true, PhonemeASR: true, PartialSpeechStream: true, ComprehensionInference: true }});

  enabledServices.PlacementManager = false;
  enabledServices.PhonPlacementManager = false;
  enabledServices.GooglePlacementManager = false;
  enabledServices.AmirabetPlacementManager = false;
  enabledServices.SpeechStream = false;
  enabledServices.GoogleComprehensionASR = false;
  enabledServices.PartialSpeechStream = false;
  enabledServices.ComprehensionInference = false;
}

export function saveComprehensionTextInput(payload, inComprehensionCallback) {
  comprehensionCallback = inComprehensionCallback;

  const services = {
    ComprehensionInference: true
  };

  let sendToSocket = {
    payload,
    services
  };
  send('processComprehensionQuestion',sendToSocket);
}

// metaObj: populated with app session data of choice
export function saveSessionAudio (testID, audioStream, metaObj, allZeros, onFailure, storyid, phraseIndex) {
  let socketData = audioStream;
  metaObj.timeRead = 0 //Stub this in so inference doesn't crash on tutor

  if (metaObj){
    if (!audioDestination) {
      metaObj.sequenceNumber = JSON.parse(JSON.stringify(sequenceNumber));
    } else {
      metaObj.sequenceNumber = JSON.parse(JSON.stringify(adhocSequence[audioDestination]));
    }
  }

  if(useSpanishPlacement){
    metaObj.languageCode = 'es-MX';
  }

  const sequenceToUse = audioDestination ? adhocSequence[audioDestination] : sequenceNumber;
  let payload = {
    data: socketData, // Audio buffer
    created: Date.now(),
    intermediate: 50, // value in ms that specifies the interval of partial returns
    phonIntermediate: 750,
    phraseId: metaObj.phraseid,
    sequenceNumber: sequenceToUse,
    done: metaObj.done ? metaObj.done : false,
    audioDestination,
    ...metaObj,
  };

  if(metaObj.flagPhrase && metaObj.done){
    payload.flagging = {flag: true}
    logSessionInfo("flagging_phrase",metaObj)
  }

  let services = metaObj.disableBackend ? { PlacementManager: enabledServices.PlacementManager, PhonPlacementManager: enabledServices.PhonPlacementManager, AmirabetPlacementManager: enabledServices.AmirabetPlacementManager, GooglePlacementManager: enabledServices.GooglePlacementManager, PhonemeASR: enabledServices.PhonemeASR, SpeechStream: false, Nrt: false, PartialSpeechStream: enabledServices.PartialSpeechStream, ComprehensionInference: enabledServices.ComprehensionInference } : enabledServices;
  oneOffAudio = metaObj.disableBackend;

  if(metaObj.comprehensionDone || metaObj.comprehensionDiscard){
    services.ComprehensionInference = true;
    payload.storyid = storyid;
    payload.phraseIndex = phraseIndex;
    metaObj.storyid = storyid;
    metaObj.phraseIndex = phraseIndex;
    metaObj.activityId = testID;

    if (metaObj.comprehensionDiscard) {
      payload.discard = true;
      metaObj.discard = true;
    }
    if (metaObj.comprehensionDone) {
      payload.done = true;
      metaObj.done = true;
    } 
  }

  let sendToSocket = {
    payload: payload,
    services: services
  };

  if(services.PlacementManager || services.PhonPlacementManager || services.SpeechStream || services.Nrt || services.GooglePlacementManager || services.PartialSpeechStream || services.ComprehensionInference){
    if((process.env.STREAM) && socket && !allZeros){
      if(!pauseRequested || metaObj.done || metaObj.discard){
        //NOTE: Do not remove! This is a stopgap solution to trigger recovery from the infamous Blob Error
        let fr = new FileReader();
        fr.readAsDataURL(audioStream);
        fr.onerror = (e) => {
          console.error('FileReader failed: ', e);
          if(onFailure){
            console.log("restarting listening");
            endUniversalSocketSession();
            onFailure();
          }
        };
        if (!payload.disableBackend) {
          if (networkMonitoringService) {
            // Only add the audioSegment representation if backend is enabled. If disabled, we will not get a corresponding onSaved event
            networkMonitoringService.enqueueAudio(payload.sequenceNumber, {
              buildSequence,
              acknowledgedSequence,
              buildAcknowledged,
              blobSize: payload.data.size,
              clearHistory: payload.clearHistory,
              disableBackend: payload.disableBackend,
              done: payload.done,
              flagPhrase: payload.flagPhrase,
              graphSuffix: payload.graphSuffix,
              intermediate: payload.intermediate,
              phonIntermediate: payload.phonIntermediate,
              phraseIndex: payload.phraseIndex,
              timeRead: payload.timeRead,
            });
          }
        }
        send('audioSegment',sendToSocket);
        if(services.SpeechStream){
          totalBytesSent += audioStream.size - 44;
          sequenceNumber++;
        }
        if (services.PartialSpeechStream) {
          adhocSequence[audioDestination]++;
        }
      }

      if(pauseRequested){
        sendPause();
        pauseRequested = false;
      }
    }
  }

  if(metaObj.done){
    stopAll();
  }
}

function processSpeechEvent(message,payload){
  switch(message){
    case "decoded":
      if (payload.service === 'PlacementManager') {
        if(DEBUG_SOCKET) console.log('%cPlacementManager', 'background: #00a1c9; color: #fff; padding: 1em;', payload.result);
      }
      if(payload.service === "PhonPlacementManager"){
        if(DEBUG_SOCKET) console.log('%cPhonPlacementmanager', 'background: #00a1c9; color: #fff; padding: 1em;', payload.result.text);
      }
      if(payload.service === "Wav2VecStreamV2"){
        if(DEBUG_SOCKET) console.log('%cWav2VecStreamV2', 'background: #00a1c9; color: #fff; padding: 1em;', payload.result.text);
      }
      if(payload.service === "GoogleSpeechStream" || payload.service === "GooglePlacementManager"){
        if(useSpanishPlacement){
          if(payload && payload.data && payload.data.results){
            let dummyPayload = parseGooglePayload(payload.data.results,true)
            onDecoded(dummyPayload)
          }
        }
        if(DEBUG_SOCKET) console.log('%cGooglePlacementManager', 'background: #00a1c9; color: #fff; padding: 1em;', payload.result.text);
      }
      if(!useGoogleNRT && !useSpanishPlacement){
        onDecoded(payload);
      }

      break;
    case "asrOutput":
      onASROutput(payload);
      break;
    case "prediction":
      onPrediction(payload);
      break;
    case "saved":
      onSaved(payload);
      break;
    case "GoogleSpeechIntermediate":
      if(useGoogleNRT && payload && payload.results){
        let dummyPayload = parseGooglePayload(payload.results,true);
        onDecoded(dummyPayload)
      }
      break;
    case "_error":
      if(DEBUG_SOCKET) console.log('%cSocket Error', 'background: #c00; color: #fff; padding: 1em;', JSON.stringify(payload, null, 0));
      break;
    case "onDetectorsEnd":
      onDetectorsEnd(payload)
      break;
    case "comprehensionInference":
      onComprehensionInference(payload)
      break;
    case "comprehensionInferenceError":
      console.log("Comprehension Dialog: Comprehension Inference Error",payload)
      logSessionInfo('on_comprehension_inference_error', payload);
      break;
    default:
      console.log("UNHANDLED MESSAGE",message);
  }
}

function parseGooglePayload(results,concatFinal){
  if(results && results[0] && results[0].alternatives[0]){
    if(results[0].isFinal && concatFinal){
      transcript += results[0].alternatives[0].transcript;
      results[0].alternatives[0].transcript = '';
    }
    let dummyPayload = {service: "PlacementManager", result: {text: results[0].alternatives[0].transcript}};
    return dummyPayload;
  }
}
function clearStream(){
  //Queuing for the speech stream
  streamQueue = [];
  headPointer = 0;
  sequenceNumber = 0;
  buildSequence = 0;
  sending = false;
}

// requests the combination of stored/available audio files
export function buildSessionAudio (testID,metaObj) {
  let buildAudioRequest =
  {
    services: { SpeechStream: true },
    version: '2.0.1',
    payload: {
      id: testID,
      activityId: testID,
      build: true,
      data: null,
      created: Date.now(),
      sequenceNumber,
      ...metaObj
    },
  }

  buildSequence = sequenceNumber;
  buildAcknowledged = false;
  //###console.log("BUILD SENT",buildSequence,Date.now());
  emit(socket, 'audioSegment', buildAudioRequest);
  if(socket){
    logSessionInfo("build_audio_sent",{timestamp: Date.now()});
  }else{
    logSessionInfo("build_audio_not_sent",{reason: "no_socket",timestamp: Date.now()});
  }
}

export function buildAdhocAudio(testID, metaObj) {
  let buildAudioRequest = {
    services: { PartialSpeechStream: true },
    version: '2.0.1',
    payload: {
      id: testID,
      activityId: testID,
      build: true,
      data: null,
      created: Date.now(),
      sequenceNumber: adhocSequence[audioDestination],
      audioDestination,
      ...metaObj
    }
  }
  emit(socket, 'audioSegment', buildAudioRequest);
}

// retrieves a bundled session audio file
export function searchSessionAudio (testID) {
  let apiName = awsmobile.aws_cloud_logic_custom[1].name;
  let path = '/stream';
  let myInit = {
    headers: {'Content-Type': 'application/json'},
    queryStringParameters: {id: testID}
  };

  return API.get(apiName, path, myInit)
  .then((resp) => resp.data)
  .catch(err => {
    console.log('SEARCH Audio failed: ', err);
  });
}

//Queuing for the speech stream
let streamQueue = [];
let sending = false;
const numRetries = 10;
let headPointer = 0;

//Throws a packet in the queue and kicks off a send if we're not already sending
// If we are sending, the sendPacket function will pick this up when it's done.
// Note: we don't dequeue when we send the packet until successful, hence the peek and not dequeue
function queuePacket(inPacket){
  streamQueue.push(inPacket);
  //Leave in for debugging console.log("PUSHED",streamQueue.length,headPointer,inPacket.body.sequenceNumber);
  if(!sending){
    sending = true;
    sendPacket(peekNextPacket(),numRetries);
  }
}

function dequeuePacket(){
  //Leave in for debugging console.log("DEQUEUING",streamQueue.length,headPointer,streamQueue[headPointer] ? streamQueue[headPointer].body.sequenceNumber : "NULL");
  let retValue = streamQueue[headPointer];
  headPointer++;
  return retValue;
}

//Get the next packet without dequeueing
function peekNextPacket(){
  if(headPointer < streamQueue.length){
    return streamQueue[headPointer];
  }else{
    return null;
  }
}

export function isSendingComplete(){
  return (buildSequence && buildAcknowledged && acknowledgedSequence >= (buildSequence-1));
}

export function sendingProgress(){
  return buildSequence ? Math.round(100*acknowledgedSequence/buildSequence) : 0;
}

//Sends the next packet, dequeues if successful, and picks up any
// new packets that have been queued in the interim.
function sendPacket(inPacket, retries){
  let apiName = awsmobile.aws_cloud_logic_custom[1].name;
  let path = '/stream';

  if(!inPacket){
    return Promise.resolve();
  }
  else{
    //Leave in for debugging console.log("SENDING",inPacket.body.sequenceNumber);
  }

  API.post(apiName, path, inPacket)
  .then(resp => {
    //On a successful post, dequeue the previous packet and send the next
    let sentPacket = dequeuePacket();
    if(sentPacket && sentPacket.body &&!sentPacket.body.data){
      //Leave in for debugging console.log("LAST PACKET!");
      clearStream();
    }else{
      let nextPacket = peekNextPacket();
      if(nextPacket){
        sendPacket(nextPacket,numRetries);
      }else{
        sending = false;
      }
    }
  })
  .catch(err => {
    console.log('Stream packet failed:', err,inPacket.body.id,inPacket.body.meta); //Leave in for debug
    if(retries && inPacket){
      console.log("Retrying speech stream:",retries); //Leave in for debug
      sendPacket(inPacket,retries-1);
    }else{
      dequeuePacket();
      sending = false;
      throw new Error(err);
    }
  });
}

export function setNetworkMonitoringService(nms) {
  networkMonitoringService = nms;
}